import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import OurGoals from './pages/OurGoals';
import GuidingPrinciples from './pages/GuidingPrinciples';
import OurCulture from './pages/OurCulture';
import OurName from './pages/OurName';
import Team from './pages/Team';
import Newsletters from './pages/Newsletters';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RegulatoryDetails from './pages/RegulatoryDetails';
import Disclaimer from './pages/Disclaimer';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isRegulatory = location.pathname === '/regulatory-details';
  const isTeam = location.pathname === '/our-team';
  const mainClass = [
    isRegulatory && 'main--regulatory',
    isTeam && 'main--team'
  ].filter(Boolean).join(' ');

  return (
    <>
      <ScrollToTop />
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div className="App">
        <Header />
        <main id="main-content" role="main" aria-label="Main content" className={mainClass || undefined}>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/our-goals" element={<OurGoals />} />
            <Route path="/guiding-principles" element={<GuidingPrinciples />} />
            <Route path="/our-culture" element={<OurCulture />} />
            <Route path="/our-name" element={<OurName />} />
            <Route path="/our-team" element={<Team />} />
            <Route path="/newsletters" element={<Newsletters />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/regulatory-details" element={<RegulatoryDetails />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
